module.exports = __webpack_public_path__ + "static/media/picornell.5f78e332.jpg";